/**
 * Technology Showcase V2 - Modal and Tab Functionality
 */

(function () {
  "use strict";

  // Wait for DOM and jQuery to be ready
  if (typeof jQuery === "undefined") {
    console.error("jQuery is required for technology-v2.js");
    return;
  }

  jQuery(document).ready(function ($) {
    // Initialize technology modal functionality
    initTechnologyModals();

    // Initialize tab switching
    initTabSwitching();

    // Left-side circle nav: active state from scroll, click to scroll
    initTechnologyNav();
  });

  /**
   * Initialize modal triggers for "Learn More" buttons
   */
  function initTechnologyModals() {
    jQuery(document).on("click", ".technology-learn-more-v2", function (e) {
      e.preventDefault();

      var $button = jQuery(this);
      var technologyId = $button.data("technology-id");
      var $modalContent = jQuery(
        '.technology-modal-content[data-technology-id="' + technologyId + '"]',
      );

      if ($modalContent.length === 0) {
        console.error(
          "Modal content not found for technology ID: " + technologyId,
        );
        return;
      }

      // Get the modal HTML
      var modalHtml = $modalContent.html();

      // Find the popup modal (should exist in footer)
      var $popupModal = jQuery("#popup-modal");

      if ($popupModal.length === 0) {
        console.error("Popup modal (#popup-modal) not found");
        return;
      }

      // Add wrapper class for styling
      $popupModal.find(".modal-dialog").addClass("technology-modal-wrapper");

      // Wrap body content and add close button on top right
      var closeBtnHtml =
        '<button type="button" class="technology-modal__close" data-dismiss="modal" aria-label="Close">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">' +
        '<path d="M12,11.3L22.3,1L23,1.7L12.7,12L23,22.3L22.3,23L12,12.7L1.7,23L1,22.3L11.3,12L1,1.7L1.7,1L12,11.3z"/>' +
        "</svg></button>";
      var wrappedHtml =
        '<div class="technology-modal__body-wrap">' +
        closeBtnHtml +
        '<div class="technology-modal__body-inner">' +
        modalHtml +
        "</div></div>";

      $popupModal.find(".modal-body").html(wrappedHtml);

      // Reset tabs to first active tab
      resetTabs($popupModal);

      // Close button: hide modal when clicked
      $popupModal.find(".technology-modal__close").on("click", function () {
        $popupModal.modal("hide");
      });

      // Open the modal
      $popupModal.modal("show");

      // Re-initialize tab switching for this modal instance
      initTabSwitching($popupModal);
    });
  }

  /**
   * Initialize tab switching functionality
   * @param {jQuery} $container - Optional container to scope tab switching (defaults to document)
   */
  function initTabSwitching($container) {
    $container = $container || jQuery(document);

    // Handle tab clicks
    $container.on("click", ".technology-modal__tab", function (e) {
      e.preventDefault();

      var $tab = jQuery(this);
      var tabNumber = $tab.data("tab");
      var $tabsContainer = $tab.closest(".technology-modal__tabs");
      var $panelsContainer = $tabsContainer.siblings(
        ".technology-modal__panels",
      );

      // Update tab states
      $tabsContainer.find(".technology-modal__tab").each(function () {
        var $currentTab = jQuery(this);
        var isActive = $currentTab.data("tab") === tabNumber;

        $currentTab
          .toggleClass("technology-modal__tab--active", isActive)
          .attr("aria-selected", isActive);
      });

      // Update panel visibility
      $panelsContainer.find(".technology-modal__panel").each(function () {
        var $panel = jQuery(this);
        var isActive = $panel.data("panel") === tabNumber;

        $panel
          .toggleClass("technology-modal__panel--active", isActive)
          .attr("aria-hidden", !isActive);
      });
    });

    // Keyboard navigation for tabs
    $container.on("keydown", ".technology-modal__tab", function (e) {
      var $tabs = jQuery(this).siblings(".technology-modal__tab").addBack();
      var currentIndex = $tabs.index(jQuery(this));
      var $targetTab = null;

      // Arrow key navigation
      if (e.key === "ArrowRight" || e.key === "ArrowDown") {
        e.preventDefault();
        $targetTab = $tabs.eq((currentIndex + 1) % $tabs.length);
      } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
        e.preventDefault();
        $targetTab = $tabs.eq((currentIndex - 1 + $tabs.length) % $tabs.length);
      } else if (e.key === "Home") {
        e.preventDefault();
        $targetTab = $tabs.first();
      } else if (e.key === "End") {
        e.preventDefault();
        $targetTab = $tabs.last();
      }

      if ($targetTab && $targetTab.length) {
        $targetTab.focus().trigger("click");
      }
    });
  }

  /**
   * Reset tabs to show the first active tab
   * @param {jQuery} $modal - The modal container
   */
  function resetTabs($modal) {
    var $firstTab = $modal.find(".technology-modal__tab").first();
    var $firstPanel = $modal.find(".technology-modal__panel").first();

    if ($firstTab.length && $firstPanel.length) {
      // Reset all tabs
      $modal.find(".technology-modal__tab").each(function () {
        var $tab = jQuery(this);
        var isFirst = $tab.is($firstTab);
        $tab
          .toggleClass("technology-modal__tab--active", isFirst)
          .attr("aria-selected", isFirst);
      });

      // Reset all panels
      $modal.find(".technology-modal__panel").each(function () {
        var $panel = jQuery(this);
        var isFirst = $panel.is($firstPanel);
        $panel
          .toggleClass("technology-modal__panel--active", isFirst)
          .attr("aria-hidden", !isFirst);
      });
    }
  }

  /**
   * Left-side circle nav: set active when section is in center of viewport, click scrolls to section
   */
  function initTechnologyNav() {
    var $nav = jQuery(".technology-nav");
    var $circles = $nav.find(".technology-nav__circle");
    var $sections = jQuery(
      ".technology-showcase-v2__grid .technology-card[id]",
    );

    if (!$circles.length || !$sections.length) return;

    var navScrollLockUntil = 0;
    var lastUpdateTime = 0;
    var throttleMs = 120;

    // Click: smooth scroll to section, then lock active updates until scroll settles
    $circles.on("click", function (e) {
      var sectionId = jQuery(this).data("section");
      var sectionEl = document.getElementById(sectionId);
      if (sectionEl) {
        e.preventDefault();
        navScrollLockUntil = Date.now() + 700;
        $circles
          .removeClass("technology-nav__circle--active")
          .attr("aria-current", null);
        jQuery('.technology-nav__circle[data-section="' + sectionId + '"]')
          .addClass("technology-nav__circle--active")
          .attr("aria-current", "true");
        sectionEl.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });

    // Update active circle: section whose center is closest to viewport center (throttled)
    function updateActiveCircle() {
      if (Date.now() < navScrollLockUntil) return;
      if (Date.now() - lastUpdateTime < throttleMs) return;
      lastUpdateTime = Date.now();

      var viewportCenter = window.innerHeight / 2;
      var closestId = null;
      var closestDist = Infinity;
      $sections.each(function () {
        var rect = this.getBoundingClientRect();
        var sectionCenter = rect.top + rect.height / 2;
        var dist = Math.abs(sectionCenter - viewportCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closestId = this.id;
        }
      });
      $circles
        .removeClass("technology-nav__circle--active")
        .attr("aria-current", null);
      if (closestId) {
        $nav
          .find('.technology-nav__circle[data-section="' + closestId + '"]')
          .addClass("technology-nav__circle--active")
          .attr("aria-current", "true");
      }
    }

    updateActiveCircle();
    jQuery(window).on("scroll.technology-nav", function () {
      requestAnimationFrame(updateActiveCircle);
    });
  }

  /**
   * Clean up when modal is closed
   */
  jQuery(document).on("hidden.bs.modal", "#popup-modal", function () {
    var $modal = jQuery(this);

    // Remove technology modal wrapper class
    $modal.find(".modal-dialog").removeClass("technology-modal-wrapper");

    // Clear modal body
    $modal.find(".modal-body").empty();
  });
})();
